module.exports = __webpack_public_path__ + "static/media/login.71a2357.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/vedio/login.mp4
// module id = Yqqz
// module chunks = 15